import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  isPending: false,
  isSuccessful: false,
  isFailure: false,
};

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.createProjectModelFromProjectRequested]: setRequestStateToPending,
    [events.createProjectModelFromProjectSucceeded]: setRequestStateToSuccess,
    [events.createProjectModelFromProjectFailed]: setRequestStateToFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
